
import { Button, Divider, Grid, Typography } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { IGroup } from "../../../models/groups";

import { useAppDispatch } from "../../../redux/hooks";
import '../../../themes/styles.css';

import { editGroup, saveGroup } from "../../../redux";

interface Props {
    onCancel: () => void,
    group: IGroup,
    editing: boolean
}

export const MyForm = ({ onCancel, group, editing }: Props) => {
    const dispatch = useAppDispatch();

    const onSave = (group: IGroup) => {
        editing ? dispatch(editGroup(group) as any) : dispatch(saveGroup(group) as any);
    }

    return (
        <Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                Add Group
            </Typography>
            <br />
            <Divider />
            <br />

            <Formik
                initialValues={group}
                onSubmit={(values) => {
                    onSave(values as any);
                    onCancel();
                }}
            // validationSchema={Yup.object({
            //     name: Yup.string()
            //         .max(15, 'Debe de tener 15 caracteres o menos')
            //         .required('Requerido'),
            // })}
            >

                {(formik) => (
                    <Form>
                        <Grid container justifyContent="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="name">Name</Typography>
                                <Field name="name" type="text" />
                                <ErrorMessage name="name" component="span" className="error-message" />
                                <br />
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container justifyContent="center">
                            <Button variant="outlined" type="reset" sx={{ width: 100 }} onClick={onCancel}>Cancel</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button variant="contained" type="submit" sx={{ width: 100 }} >Save</Button>
                        </Grid>
                    </Form>
                )
                }
            </Formik>
        </Grid >
    )
}

